const getABVariationId = (abTests, testName) =>
  abTests && abTests[testName] ? abTests[testName].variationId : -1;

export default getABVariationId;
